import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Segment } from 'semantic-ui-react';
import classnames from 'classnames/bind';
import Icon from '../../../elementals/icon';
import styles from '../styles.scss';
const cx = classnames.bind(styles);
export const BADGE_ORDER_PRIORITY = {
    FIRST: 1,
    SECOND: 2,
    THIRD: 3,
    FOURTH: 4,
    FIFTH: 5,
    SIXTH: 6,
    SEVENTH: 7,
    EIGHTH: 8,
    HIGH: 1,
    MEDIUM: 4,
    LOW: 7,
};
export const BADGE_MODE = {
    EXPANDED: 'expanded',
    CONDENSED: 'condensed',
    V2: 'v2',
};
export const CondensedBadge = ({ elmId, title, iconName, icon }) => (_jsxs("div", { className: cx('badge-condensed'), "data-elm-id": `${elmId}_badge`, children: [React.isValidElement(icon) ? (icon) : (_jsx(Icon, { iconStyle: 'light', size: 'large', className: cx('icon'), name: iconName })), ' ', _jsx("label", { "data-elm-id": `${elmId}_label`, children: title })] }));
CondensedBadge.propTypes = {
    elmId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    iconName: PropTypes.string,
    icon: PropTypes.string,
};
export default class ListingBadge extends Component {
    static renderPriority = BADGE_ORDER_PRIORITY.MEDIUM;
    static titleIcon = 'check';
    static title = '';
    static textIcon = 'check';
    static summary = 'Yes';
    static contentPositive = true;
    static content = '';
    static shouldBeHoisted = false;
    static propTypes = {
        listing: PropTypes.object.isRequired,
        eventSubscriber: PropTypes.func,
        mode: PropTypes.oneOf(Object.values(BADGE_MODE)),
    };
    static defaultProps = {
        eventSubscriber: _.noop,
        mode: BADGE_MODE.EXPANDED,
    };
    state = { showContent: false };
    static shouldBeIncluded(listing, badgeMode) {
        return false;
    }
    static condensedTitleIcon = '';
    static condensedTitle = '';
    emitEvent(evtRef, e) {
        this.props.eventSubscriber(evtRef, e || null);
    }
    toggleContent = () => {
        this.setState({
            showContent: !this.state.showContent,
        });
    };
    render() {
        const showContent = this.state.showContent;
        const content = this.constructor.content || this.content;
        const summary = this.summary || this.constructor.summary;
        const contentPositive = this.contentPositive || this.constructor.contentPositive;
        const { titleIcon, title, condensedTitleIcon, condensedTitle } = this.constructor;
        const elmId = _.snakeCase(title);
        return this.props.mode === BADGE_MODE.CONDENSED ? (_jsx(CondensedBadge, { elmId: elmId, title: condensedTitle || title || summary, iconName: condensedTitleIcon || titleIcon, icon: titleIcon })) : (_jsxs(Segment, { className: cx('badge'), children: [_jsxs("div", { className: cx('u-display-f', 'u-pointer-cursor'), "data-elm-id": `${elmId}_badge_header`, onClick: this.toggleContent, children: [_jsxs("div", { className: cx('u-display-f', 'u-display-f-between', 'u-stretch', 'badge-title'), children: [_jsxs("div", { "data-elm-id": `${elmId}_title`, children: [_jsx(Icon, { iconStyle: 'light', className: cx('title-icon'), name: titleIcon }), ' ', title] }), _jsx("div", { "data-elm-id": `${elmId}_summary`, children: _jsxs("strong", { className: cx(contentPositive ? 'color-success' : 'color-error'), children: [' ', summary, ' '] }) })] }), !!content && (_jsx("div", { className: cx('u-display-f-end', 'icon-container'), children: _jsx(Icon, { name: 'angle-down', className: cx('toggle', { 'icon-up': showContent }), iconStyle: 'light', size: 'large' }) }))] }), _jsx("div", { "data-elm-id": `${elmId}_badge_content`, children: _jsx("div", { className: cx('badge-hidden-content', 'scroll-up', {
                            hidden: !showContent,
                        }), children: content }) })] }));
    }
}
//# sourceMappingURL=base.js.map